import { compare } from 'compare-versions'
import pRetry from 'p-retry'
import { native } from '../native'

export async function getReceiptSystemAccountIdSafe(
  appVersion: string,
): Promise<string | null> {
  if (!compare(appVersion, '5.10.0', '>=')) return null
  try {
    return await pRetry(
      async () => {
        const result = await native.iap.getReceiptSystemAccountId()
        if (!result.success) throw new Error(result.error)
        return result.data.receipt_system_account_id
      },
      { retries: 2 }, // retries=2 means 3 attempts total (1 initial + 2 retries)
    )
  } catch (error) {
    void native.general
      .logNonFatalError({
        name: 'failed_to_get_receipt_system_account_id',
        code: 1,
        params: {
          message: String(error),
          app_version: appVersion,
        },
      })
      .catch(() => {})
    return null
  }
}
